var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgA3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 498,
    height: 421,
    fill: "none",
    viewBox: "0 0 498 421",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.541
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f)",
    opacity: 0.568
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 249,
    cy: 210.5,
    fill: "url(#paint0_linear)",
    rx: 113,
    ry: 73.676
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f)",
    opacity: 0.424
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2A6ECF",
    fillRule: "evenodd",
    d: "M202.842 273.048l31.864-12.086 32.88-44.906L271.999 192l11.092-13.502-40.124 4.274L222.999 206l-11 22.357-9.157 44.691z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_radial)",
    fillRule: "evenodd",
    d: "M176 278.217c47.5-12.075 64.526-15.974 82.263-71.818 17.737-55.845 59.91-70.018 93.823-75.733C386 124.951 417.06 259.97 417.06 259.97l-110.291 85.487-163.396 23.267S128.5 290.291 176 278.217z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f",
    width: 497.828,
    height: 419.18,
    x: 0.086,
    y: 0.91,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur",
    stdDeviation: 67.957
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f",
    width: 183.544,
    height: 197.845,
    x: 151.194,
    y: 126.85,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur",
    stdDeviation: 25.824
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(56.96518 117.5516 -129.96937 62.9828 249.606 210.959)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFEFF",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 136,
    x2: 136,
    y1: 136.824,
    y2: 284.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72EBDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1DA5E2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgA3);
export default __webpack_public_path__ + "static/media/a3.ec3562db7fd7bd5ed1d2b48650ec9af5.svg";
export { ForwardRef as ReactComponent };